module.exports = __webpack_public_path__ + "media/radiation colitis.cc68cfe9.wav";